"use client";

import { capturePostHogException } from "@klarify/posthog";
import { useEffect } from "react";
import AppErrorFallback from "./app-error-fallback";

export default function GlobalError({
	error,
}: {
	error: Error & { digest?: string };
}) {
	// Last-resort boundary: React swallowed the error, so nothing else reports it.
	useEffect(() => {
		capturePostHogException(error, { digest: error.digest, global: true });
	}, [error]);

	return (
		<html lang="en">
			<body>
				<AppErrorFallback error={error} />
			</body>
		</html>
	);
}
